import { api } from '@marketplace-web/core-api/core-api-client-util'

import { BusinessAccountsTermsOfUseResp } from '../types/terms-content'

export const getBusinessAccountsTermsOfUseContent = () =>
  api.get<BusinessAccountsTermsOfUseResp>('/pro_terms_of_use')

export const getPrivateBetaTermsOfUseContent = () =>
  api.get<BusinessAccountsTermsOfUseResp>('/private_beta_terms_of_use')

export const getProTermsAndConditionsContent = ({
  isPreviousVersion,
}: {
  isPreviousVersion: boolean | undefined
}) =>
  api.get<BusinessAccountsTermsOfUseResp>('/pro_terms_and_conditions', {
    params: { old: isPreviousVersion },
  })
